import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICategoriesState, ICategory, ICategoryPage } from "../types/category";

const initialState: ICategoriesState = {
  categories: [],
  category: null,
  total: 0,
  limit: 20,
  offset: 0,
  loading: false,
  loadingCategoryId: null,
};

const category = createSlice({
  name: "category",
  initialState,
  reducers: {
    setCategories: (state, action: PayloadAction<ICategoryPage>) => {
      state.categories = action.payload.data;
      state.total = action.payload.total;
      state.limit = action.payload.limit;
      state.offset = action.payload.offset;
    },

    setCategory: (state, action: PayloadAction<ICategory>) => {
      state.category = action.payload;
    },

    createCategory: (state, action: PayloadAction<ICategory>) => {
      state.categories = [action.payload, ...state.categories];
    },

    updateCategory: (state, action: PayloadAction<ICategory>) => {
      state.categories = state.categories.map((item) =>
        item.id === action.payload.id ? action.payload : item,
      );
      if (state.category?.id === action.payload.id) {
        state.category = { ...state.category, ...action.payload };
      }
    },

    deleteCategory: (state, action: PayloadAction<number>) => {
      state.categories = state.categories.filter(
        (category) => category.id !== action.payload,
      );

      if (state.category?.id === action.payload) state.category = null;
    },

    setCategoryLoading: (state) => {
      state.loading = true;
    },

    disableCategoryLoading: (state) => {
      state.loading = false;
    },

    setLoadingCategoryId: (state, action: PayloadAction<number | null>) => {
      state.loadingCategoryId = action.payload;
    },
  },
});

export const {
  setCategories,
  setCategory,
  createCategory,
  updateCategory,
  deleteCategory,
  setCategoryLoading,
  disableCategoryLoading,
  setLoadingCategoryId,
} = category.actions;

export default category.reducer;
